module.exports = __webpack_public_path__ + "static/media/DANGER_RAFFLE_FAST.9e93ac87.mp3";